import { useState, useEffect, useRef } from "react";

export const AddressAutocomplete = ({ value, onChange, onSelect, placeholder, testid, Icon, cityOnly = false, bias = "" }) => {
  const [q, setQ] = useState(value || "");
  const [res, setRes] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef();
  const box = useRef();

  useEffect(() => { setQ(value || ""); }, [value]);
  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const search = (v) => {
    setQ(v); onChange && onChange(v);
    clearTimeout(timer.current);
    if (v.trim().length < 3) { setRes([]); setOpen(false); return; }
    timer.current = setTimeout(async () => {
      try {
        const type = cityOnly ? "&featureType=city" : "";
        const biased = !cityOnly && bias && !v.toLowerCase().includes(bias.toLowerCase()) ? `${v}, ${bias}` : v;
        const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&countrycodes=fr${type}&q=${encodeURIComponent(biased)}`;
        const r = await fetch(url, { headers: { "Accept-Language": "fr" } });
        const d = await r.json();
        setRes(Array.isArray(d) ? d : []); setOpen(true);
      } catch (e) { console.warn("geocode failed", e); }
    }, 350);
  };

  const pick = (r) => {
    const a = r.address || {};
    const city = a.city || a.town || a.village || a.municipality || "";
    const label = cityOnly ? (city || r.display_name.split(",")[0]) : r.display_name;
    setQ(label); setOpen(false); setRes([]);
    onChange && onChange(label);
    onSelect && onSelect({ label: r.display_name, city, lat: parseFloat(r.lat), lng: parseFloat(r.lon) });
  };

  return (
    <div className="relative" ref={box}>
      <div className="flex items-center gap-2 border-2 border-cream-bg focus-within:border-urban-teal rounded-2xl px-3 py-2.5 transition-colors bg-white">
        {Icon && <Icon size={18} className="text-street-gold shrink-0" />}
        <input value={q} onChange={(e) => search(e.target.value)} onFocus={() => res.length && setOpen(true)} placeholder={placeholder} className="w-full outline-none bg-transparent text-urban-teal" data-testid={testid} autoComplete="off" />
      </div>
      {open && res.length > 0 && (
        <ul className="absolute z-40 left-0 right-0 bg-white rounded-xl shadow-warm-lg mt-1 max-h-60 overflow-auto border border-cream-bg" data-testid={`${testid}-list`}>
          {res.map((r) => (
            <li key={r.place_id} onClick={() => pick(r)} className="px-3 py-2 text-sm text-urban-teal hover:bg-cream-bg cursor-pointer border-b border-cream-bg last:border-0">{r.display_name}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
